/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-16 17:40:09
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-14 13:27:49
 */
import { HOME_NAV_KEY } from '@src/utils/constant/common';

const loader = (name: string) => async () => {
  // @ts-ignore
  const entrance = await import(/* webpackChunkName: "f.home" */ './');
  return entrance[name];
};

import { IRoute } from '@src/types';

export const childRoutes: IRoute[] = [
  {
    path: `${HOME_NAV_KEY}/:navKey/:tabKey`,
    name: 'HomeTab',
    isIndex: true,
    load: loader('Home')
  }
];

export default {
  path: '/',
  name: 'Home',
  childRoutes
};
